export enum PermissionsActionsEnum {
  LOAD_PERMISSIONS = 1,
  CHANGE_PERMISSIONS = 2,
}
